ManageProperties.store.state = {
};